import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=b4eed03c&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"
import style0 from "./AppView.vue?vue&type=style&index=0&id=b4eed03c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4eed03c",
  null
  
)

export default component.exports